module.exports = __webpack_public_path__ + "54b9a2ff3971554da60358eb1327dd6a.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/18-Betsolutions-Betting-Shop.png
// module id = 1740
// module chunks = 2